import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import breakpoint from 'styled-components-breakpoint';

const Icon = styled.span`
    margin-right: 5px;
    font-size: ${props => (props.iconSize ? props.iconSize : '16px')};
     color: #007DC6;
`;

const StyledLink = styled(Link)`
 :hover, :active, :focus {
     text-decoration: none;
 }`;

const ButtonText = styled.span`
    height: 24px;
    color: #007DC6;
    font-family: Lato;
    font-size: ${props => props.fontSize || '16px'};
    line-height: 24px;
    text-align: right;
`;

const ChannelActionWrapper = styled.button`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: none;
    padding: 0;
    text-transform: none;
    letter-spacing: 0px;
    outline: none;
    background-color: #fff;

    :hover {
        text-decoration: none;

        span:nth-child(2){
            text-decoration: underline;
        }
    }

    ${breakpoint('xs', 'sm')`
        display: none;
    `}
`;


export const ChannelActionButton = ({ icon, iconSize, text = '', onClick, fontSize }) => (
    <ChannelActionWrapper onClick={onClick} >
        <Icon className={icon} iconSize={iconSize} key={0}></Icon>
        <ButtonText fontSize={fontSize} key={1}>{text}</ButtonText>
    </ChannelActionWrapper>);

export const ChannelActionLink = ({ icon, iconSize, text = '', fontSize, entityUrl, target = null }) => (
    <ChannelActionWrapper>
        <StyledLink to={entityUrl} target={target} title="View in Admin">
            <Icon className={icon} iconSize={iconSize} key={0}></Icon>
            <ButtonText fontSize={fontSize} key={1}>{text}</ButtonText>
        </StyledLink>
    </ChannelActionWrapper>);



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/ChannelActions.js